import {apiBase} from 'api/base.js';

const ActivityImportRetryAPI = {
  create: (params) => {
    return apiBase.request('/admin/activity_import_retry', 'POST', params);
  }
};

export {ActivityImportRetryAPI as activityImportRetryAPI};
